import React, { useState } from 'react';
import { Tabs, Row, Col, Card } from 'antd';
import SingleCollectionList from './SingleCollectionList';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleCategoryFile } from '../../redux/SingleCollectionCategory/action';

const { TabPane } = Tabs;

const CollectionActiveTab = ({ fileCategories , collectionId }) => {


    const singleCategoryData = useSelector((state)=>state.singleCategoryFile.singlecategoryData)




    const [activeTab, setActiveTab] = useState("summary");

    const dispatch = useDispatch()


    const handleFetchDataTab = (categoryId) => {
        dispatch(getSingleCategoryFile(collectionId, categoryId))
    }

    const handleTabChange = (key) => {
        setActiveTab(key);
        handleFetchDataTab(key);
    };
    
    return (
        <Tabs activeKey={activeTab} onChange={handleTabChange}>
            <TabPane tab="Summary" key="summary">
                <div gutter={16} style={{ width: '100%' }}>
                    {fileCategories?.map((category) => (
                        <SingleCollectionList key={category.id} data={category} />
                    ))}
                </div>
            </TabPane>
            {fileCategories?.map((category) => (
                <TabPane tab={category.name} key={category.id.toString()}>
                    {activeTab === category.id.toString() && (
                        <div style={{ width: '100%' }}>
                            <SingleCollectionList data={singleCategoryData?.data} header={category.name} meta={singleCategoryData?.meta}/>
                        </div>
                    )}
                </TabPane>
            ))}
        </Tabs>
    )
}

export default CollectionActiveTab
